import { Button } from '@components/button';
import { Group } from '@components/layout';
import { useModal } from '@components/modal';
import { Organization } from '@generated/graphql';
import { Stack } from '@mui/material';
import {
  OrganizationsMembersInviteMemberModal,
  OrganizationsMembersInviteMemberModalHelpContent,
} from '@subsets/organizations';
import { navigate } from 'gatsby';
import { LandingPageHeader } from '../LandingPageHeader';
import { LandingPageOrganizationContent } from './LandingPageOrganizationContent';
import { LandingPageOrganizationDetails } from './LandingPageOrganizationDetails';
import { OrganizationExpirationWrapper } from './expiration';

export const LandingPageOrganization = ({ organization }: { organization: Organization }) => {
  const navigateToOrganizationSettings: () => Promise<void> = async () => {
    await navigate(`/organizations/${organization.organizationId}/settings`);
  };

  const { showModal: openInviteMemberModal } = useModal({
    component: OrganizationsMembersInviteMemberModal,
    componentProps: {
      organizationId: organization?.organizationId,
      organizationRole: organization?.role,
    },
    modalProps: {
      title: 'Invite a new organization member',
      help: OrganizationsMembersInviteMemberModalHelpContent,
    },
  });
  if (!organization) {
    return null;
  }
  return (
    <>
      <Stack height="100%" gap={5}>
        <LandingPageHeader title={organization.name} sx={{ mb: 0 }}>
          <Group gap={4}>
            <Button sx={{ minWidth: '100px' }} onClick={navigateToOrganizationSettings}>
              Settings
            </Button>
            <Button sx={{ minWidth: '100px' }} onClick={openInviteMemberModal}>
              Invite
            </Button>
          </Group>
        </LandingPageHeader>
        <LandingPageOrganizationDetails organizationId={organization.organizationId} />
        <LandingPageOrganizationContent organization={organization} />
      </Stack>
      <OrganizationExpirationWrapper {...organization} />
    </>
  );
};
